import { useState } from "react";
import type { FormEvent } from "react";
import { KeyRound, ShieldCheck } from "lucide-react";
import { clearToken, setToken, verifyToken } from "../api/client.js";

interface LoginGateProps {
  onAuthenticated: () => void;
}

export function LoginGate({ onAuthenticated }: LoginGateProps) {
  const [value, setValue] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [checking, setChecking] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    const token = value.trim();
    if (!token) {
      setError("Enter a token");
      return;
    }
    setChecking(true);
    setError(null);
    setToken(token);
    const ok = await verifyToken();
    setChecking(false);
    if (ok) {
      onAuthenticated();
      return;
    }
    clearToken();
    setError("Token rejected by the server");
  }

  return (
    <div className="login">
      <form className="login__card" onSubmit={handleSubmit}>
        <h1 className="login__title">
          <ShieldCheck size={20} aria-hidden="true" />
          JammSante Monitoring
        </h1>
        <p className="subtle" style={{ margin: 0 }}>
          Paste the monitoring bearer token to access the dashboard. It is kept only in this
          browser session.
        </p>
        <div className="field">
          <label htmlFor="token">Monitoring token</label>
          <input
            id="token"
            type="password"
            autoComplete="off"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder="MONITORING_TOKEN"
            aria-invalid={error !== null}
          />
        </div>
        {error && <div className="login__error">{error}</div>}
        <button type="submit" className="iconbtn iconbtn--primary" disabled={checking}>
          <KeyRound size={15} aria-hidden="true" />
          {checking ? "Verifying..." : "Unlock dashboard"}
        </button>
      </form>
    </div>
  );
}
